import { CostCenterAssignment, FormattedAssignment } from './types'

export const formatAssignments = (
  assignments: CostCenterAssignment[],
  hasNewStructureEnabled = false
): FormattedAssignment[] => {
  return assignments.map((assignment) => {
    // Base formatted assignment
    const costCenter = assignment.costCenter
    const workplaceCostCenter = assignment.workplaceCostCenter
    const jobCatalogCostCenter = assignment.jobCatalogCostCenter

    const name = costCenter?.name ?? workplaceCostCenter?.name ?? jobCatalogCostCenter?.name ?? ''

    // Format cost center names with code if available
    const formatCostCenterName = (
      cc: { code?: string | null; name: string } | null | undefined
    ) => {
      if (!cc) return undefined
      return cc.code ? `${cc.code} - ${cc.name}` : cc.name
    }

    const formatted: FormattedAssignment = {
      name,
      id: String(assignment.id),
      percentage: assignment.percentage,
      startDate: assignment.startDate,
      endDate: assignment.endDate ?? undefined,
      costCenterId: hasNewStructureEnabled ? undefined : assignment.costCenter?.id,
      isDefault: assignment.isDefault ?? false,
      workplaceCostCenterId: assignment.workplaceCostCenter?.id,
      workplaceCostCenterName: formatCostCenterName(workplaceCostCenter),
      jobCatalogCostCenterId: assignment.jobCatalogCostCenter?.id,
      jobCatalogCostCenterName: formatCostCenterName(jobCatalogCostCenter),
    }

    return formatted
  })
}
